import React from "react";

import {
  ListItem,
  ListItemAvatar,
  Avatar,
  IconButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { addressToString } from "../utils/utils";
import { Apartment, House, Delete, Edit } from "@mui/icons-material";


import constants from "../static/constants.json";

type PropertyListItemProps = {
  property: any;
  onSelect: () => void;
  onDelete: () => void;
};

const PropertyListItem = ({ property, onSelect, onDelete }: PropertyListItemProps) => {
  const getIconContent = () => {
    if (property.type.id === constants.propertyType.house) return <House />;
    else return <Apartment />;
  };
  return (
    <ListItem
      alignItems="flex-start"
      style={{ border: "1px none green" }}
      secondaryAction={
        <>
          <IconButton edge="end" aria-label="delete">
            <Edit onClick={onSelect}/>
          </IconButton>
          {"   "}
          <IconButton edge="end" aria-label="delete">
            <Delete onClick={onDelete} color="error"/>
          </IconButton>
        </>
      }
    >
      <ListItemAvatar>
        <Avatar>{getIconContent()}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={addressToString(property.address)}
        secondary={
          <React.Fragment>
            <Typography
              component="span"
              variant="body2"
              sx={{ color: "text.primary", display: "inline" }}
            >
              {property.address.zip}
            </Typography>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

export default PropertyListItem;
